import { DownloadOutlined } from '@ant-design/icons'
import { Button, Tag } from 'antd'

import { queryJournalPageApi } from '@eastcoal/api/finance/journalOperation/queryJournalPage'

import { RemoteTable } from '@eastcoal/common/components/RemoteTable'
import { pretty } from '@eastcoal/common/utils/decimal'
import { mapNumberEnumOptions } from '@eastcoal/common/utils/enums'

import { DateRangePicker } from '@eastcoal/formily/components/DatePicker'
import { Select } from '@eastcoal/formily/components/Select'

import { BizType, BizTypeTextMap } from '@eastcoal/shared/enums/BizType'
import {
  JournalChangeItem,
  JournalChangeItemMap
} from '@eastcoal/shared/enums/JournalChangeItem'
import {
  JournalChangeType,
  JournalChangeTypeMap,
  isExpense,
  isIncome
} from '@eastcoal/shared/enums/JournalChangeType'

import { JournalListProps, AccountJournalTableProps } from './interface'

const columns: AccountJournalTableProps['columns'] = [
  {
    title: '公司名称',
    dataIndex: 'memberName',
    align: 'center'
  },
  {
    title: '记账时间',
    dataIndex: 'createdTime',
    align: 'center',
    width: 140
  },
  {
    title: '用途',
    dataIndex: 'changeItem',
    align: 'center',
    width: 100,
    render(value) {
      return (
        <Tag variant='filled'>
          {JournalChangeItemMap[value as JournalChangeItem]}
        </Tag>
      )
    }
  },
  {
    title: '变动类型',
    dataIndex: 'changeType',
    align: 'center',
    width: 100,
    render(value) {
      const color = isIncome(value) ? 'green' : isExpense(value) ? 'red' : ''
      return (
        <Tag color={color} variant='filled'>
          {JournalChangeTypeMap[value as JournalChangeType]}
        </Tag>
      )
    }
  },
  {
    title: '交易金额',
    dataIndex: 'changeAmount',
    align: 'right',
    render(value) {
      return pretty(Math.abs(value))
    }
  },
  {
    title: '余额',
    dataIndex: 'balance',
    align: 'right',
    valueType: 'digit'
  },
  {
    title: '可用余额',
    dataIndex: 'activeBalance',
    align: 'right',
    valueType: 'digit'
  },
  {
    title: '冻结中金额',
    dataIndex: 'freezeAmount',
    align: 'right',
    valueType: 'digit'
  },
  {
    title: '交易明细',
    align: 'center',
    render(_, { bizType, changeItem, remark }) {
      return `${BizTypeTextMap[bizType as BizType]} ${
        JournalChangeItemMap[changeItem as JournalChangeItem]
      } ${remark ?? ''}`
    }
  }
]

const searchForm: AccountJournalTableProps['searchForm'] = {
  name: 'memberJournalSearchForm',
  schema: [
    {
      title: '用途',
      name: 'changeItem',
      type: 'number',
      enum: mapNumberEnumOptions(JournalChangeItemMap),
      'x-component': Select
    },
    {
      title: '类型',
      name: 'changeType',
      type: 'number',
      enum: mapNumberEnumOptions(JournalChangeTypeMap),
      'x-component': Select
    },
    {
      name: '[startTime, endTime]',
      type: 'array',
      'x-component': DateRangePicker
    }
  ],
  actions: [
    <Button key='export' icon={<DownloadOutlined />} type='primary'>
      导出
    </Button>
  ]
}

export const JournalList = ({ memberId }: JournalListProps) => {
  return (
    <RemoteTable
      sticky
      api={queryJournalPageApi}
      columns={columns}
      readyRequest={!!memberId}
      refreshDeps={[memberId]}
      requestParams={{ memberId }}
      rowKey='id'
      searchForm={searchForm}
    />
  )
}
